<template>
  <div style="width: 100%;height: 100%;background: #fbfbfb;">
    <Header :loginState="loginState" @changeSuspendState="changeSuspendState"
    @changeLoginState="changeLoginState" @changeSuspendType="changeSuspendType"></Header>
    <div class="vip-body">
      <div class="vip-box mt-30">
        <h2 class="vip-title mt-10">
          <i class="iconC-grow-up"></i>
          101游戏会员成长体系
        </h2>
        <div class="vip-group-up">
          <p style="text-align: center;">
            <div class="vip-group-img">
              <img src="../../assets/image/icon_progress.jpg">
            </div>
            <ul class="vip-group-ul">
              <li class="vip-group-li">
                <span style="margin-top: 48px;" class="vip-group-span">非玩家</span>
              </li>
              <li class="vip-group-li" style="margin-left: 18px;">
                <img :src="vipList[1].vsrc" class="vip-level-1">
                <span style="color: #ff7e0e;" class="vip-group-span">大玩家</span>
              </li>
              <li class="vip-group-li" style="margin-left: 55px;">
                <img :src="vipList[2].vsrc" class="vip-level-2">
                <span style="color: #ff7e0e;" class="vip-group-span">大玩家</span>
              </li>
              <li class="vip-group-li" style="margin-left: 52px;">
                <img :src="vipList[3].vsrc" class="vip-level-3">
                <span style="color: #ff7e0e;" class="vip-group-span">大玩家</span>
              </li>
              <li class="vip-group-li" style="margin-left: 54px;">
                <img :src="vipList[4].vsrc" class="vip-level-4">
                <span style="color: #ff7f0a;" class="vip-group-span">超级玩家</span>
              </li>
              <li class="vip-group-li" style="margin-left: 55px;">
                <img :src="vipList[5].vsrc" class="vip-level-5">
                <span style="color: #ff7f0a;" class="vip-group-span">超级玩家</span>
              </li>
              <li class="vip-group-li" style="margin-left: 52px;">
                <img :src="vipList[6].vsrc" class="vip-level-6">
                <span style="color: #ff7f0a;" class="vip-group-span">超级玩家</span>
              </li>
              <li class="vip-group-li" style="margin-left: 52px;">
                <img :src="vipList[7].vsrc" class="vip-level-7">
                <span style="color: #ff2600;" class="vip-group-span">头号玩家</span>
              </li>
            </ul>
          </p>
          <div class="point-box">
            <a class="point-1" href="javascript:;" @mouseover="mouseOver(1)" @mouseout="mouseOut" :class="{current:tabDirector == 1}">
              <span class="line-horizontal"></span>
              <span class="line-vertical"></span>
            </a>
            <a class="point-2" href="javascript:;" @mouseover="mouseOver(2)" @mouseout="mouseOut" :class="{current:tabDirector == 2}">
              <span class="line-horizontal"></span>
              <span class="line-vertical"></span>
            </a>
            <a class="point-3" href="javascript:;" @mouseover="mouseOver(3)" @mouseout="mouseOut" :class="{current:tabDirector == 3}">
              <span class="line-horizontal"></span>
              <span class="line-vertical"></span>
            </a>
            <a class="point-4" href="javascript:;" @mouseover="mouseOver(4)" @mouseout="mouseOut" :class="{current:tabDirector == 4}">
              <span class="line-horizontal"></span>
              <span class="line-vertical"></span>
            </a>
            <a class="point-5" href="javascript:;" @mouseover="mouseOver(5)" @mouseout="mouseOut" :class="{current:tabDirector == 5}">
              <span class="line-horizontal"></span>
              <span class="line-vertical"></span>
            </a>
            <a class="point-6" href="javascript:;" @mouseover="mouseOver(6)" @mouseout="mouseOut" :class="{current:tabDirector == 6}">
              <span class="line-horizontal"></span>
              <span class="line-vertical"></span>
            </a>
            <a class="point-7" href="javascript:;" @mouseover="mouseOver(7)" @mouseout="mouseOut" :class="{current:tabDirector == 7}">
              <span class="line-horizontal"></span>
              <span class="line-vertical"></span>
            </a>
          </div>
          <div class="pop-grow">
            <div class="pop-list pop-list-1" v-show="tabDirector == 1" @mouseover="mouseOver(1)" @mouseout="mouseOut">
              <span class="triangle-h"></span>
              <dl>
                <dt>
                  <i class="iconC iconC-club-s"></i>
                  平台特权
                </dt>
                <dd>
                  <a href="javascript:;" target="_blank">
                    <i>•</i>生日祝福
                  </a>
                </dd>
                <dd>
                  <a href="javascript:;" target="_blank">
                    <i>•</i>身份图标
                  </a>
                </dd>
              </dl>
              <dl>
                <dt>
                  <i class="iconC iconC-hotline-s"></i>
                  服务特权
                </dt>
                <dd>
                  <a href="javascript:;" target="_blank">
                    <i>•</i>限时处理
                  </a>
                </dd>
                <dd>
                  <a href="javascript:;" target="_blank">
                    <i>•</i>客服热线
                  </a>
                </dd>
                <dd>
                  <a href="javascript:;" target="_blank">
                    <i>•</i>自助服务
                  </a>
                </dd>
              </dl>
            </div>
          </div>
          <div class="pop-list pop-list-2" v-show="tabDirector == 2" @mouseover="mouseOver(2)" @mouseout="mouseOut">
            <span class="triangle-h"></span>
            <dl>
              <dt>
                <i class="iconC iconC-club-s"></i>
                平台特权
              </dt>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>生日祝福
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>身份图标
                </a>
              </dd>
            </dl>
            <dl>
              <dt>
                <i class="iconC iconC-hotline-s"></i>
                服务特权
              </dt>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>限时处理
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>客服热线
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>自助服务
                </a>
              </dd>
            </dl>
          </div>
          <div class="pop-list pop-list-3" v-show="tabDirector == 3" @mouseover="mouseOver(3)" @mouseout="mouseOut">
            <span class="triangle-h"></span>
            <dl>
              <dt>
                <i class="iconC iconC-club-s"></i>
                平台特权
              </dt>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>生日祝福
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>身份图标
                </a>
              </dd>
            </dl>
            <dl>
              <dt>
                <i class="iconC iconC-hotline-s"></i>
                服务特权
              </dt>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>限时处理
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>客服热线
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>自助服务
                </a>
              </dd>
            </dl>
          </div>
          <div class="pop-list pop-list-4" v-show="tabDirector == 4" @mouseover="mouseOver(4)" @mouseout="mouseOut">
            <span class="triangle-h"></span>
            <dl>
              <dt>
                <i class="iconC iconC-club-s"></i>
                平台特权
              </dt>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>生日祝福
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>身份图标
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>生日礼包
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>活动特权
                </a>
              </dd>
            </dl>
            <dl>
              <dt>
                <i class="iconC iconC-hotline-s"></i>
                服务特权
              </dt>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>预约服务
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>建议反馈
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>限时处理
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>客服热线
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>自助服务
                </a>
              </dd>
            </dl>
          </div>
          <div class="pop-list pop-list-5" v-show="tabDirector == 5" @mouseover="mouseOver(5)" @mouseout="mouseOut">
            <span class="triangle-h"></span>
            <dl>
              <dt>
                <i class="iconC iconC-club-s"></i>
                平台特权
              </dt>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>生日祝福
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>身份图标
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>生日礼包
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>活动特权
                </a>
              </dd>
            </dl>
            <dl>
              <dt>
                <i class="iconC iconC-hotline-s"></i>
                服务特权
              </dt>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>数据恢复
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>预约服务
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>建议反馈
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>限时处理
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>充值返利
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>客服热线
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>自助服务
                </a>
              </dd>
            </dl>
          </div>
          <div class="pop-list pop-list-6" v-show="tabDirector == 6" @mouseover="mouseOver(6)" @mouseout="mouseOut">
            <span class="triangle-s"></span>
            <dl>
              <dt>
                <i class="iconC iconC-club-s"></i>
                平台特权
              </dt>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>生日祝福
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>身份图标
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>生日礼包
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>活动特权
                </a>
              </dd>
            </dl>
            <dl>
              <dt>
                <i class="iconC iconC-hotline-s"></i>
                服务特权
              </dt>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>数据恢复
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>专属管家
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>预约服务
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>建议反馈
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>限时处理
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>充值返利
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>客服热线
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>自助服务
                </a>
              </dd>
            </dl>
          </div>
          <div class="pop-list pop-list-7" v-show="tabDirector == 7" @mouseover="mouseOver(7)" @mouseout="mouseOut">
            <span class="triangle-s"></span>
            <dl>
              <dt>
                <i class="iconC iconC-club-s"></i>
                平台特权
              </dt>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>生日祝福
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>身份图标
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>生日礼包
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>活动特权
                </a>
              </dd>
            </dl>
            <dl>
              <dt>
                <i class="iconC iconC-hotline-s"></i>
                服务特权
              </dt>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>数据恢复
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>专属管家
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>预约服务
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>建议反馈
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>限时处理
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>充值返利
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>客服热线
                </a>
              </dd>
              <dd>
                <a href="javascript:;" target="_blank">
                  <i>•</i>自助服务
                </a>
              </dd>
            </dl>
          </div>
        </div>
        <div class="vip-add">
          成长值 =
          <span class="color-orange">充值成功</span>
          +
          <span class="color-red">任务成长</span>
          +
          <span class="color-green">活动成长</span>
          -
          <span class="color-blue">过期成长值</span>
        </div>
      </div>
      <div class="vip-box mt-40 p-40">
        <h2 class="vip-title-s">成长体系计算规则</h2>
        <p>
          <br>
          成长体系目前总计7个阶段,大玩家V1~V3,超级玩家V4~V6,和独特的头号玩家V7。具体的成长阶段取决于“成长值”对应关系表如下：
        </p>
        <br>
        <table cellspacing="0" cellpadding="0" bordercolor="#f5f5f5" border="1">
          <tbody>
            <tr>
              <th width="100">等级</th>
              <th>非VIP</th>
              <th>大玩家V1</th>
              <th>大玩家V2</th>
              <th>大玩家V3</th>
              <th>超级玩家V4</th>
              <th>超级玩家V5</th>
              <th>超级玩家V6</th>
              <th>头号玩家V7</th>
            </tr>
            <tr>
              <td>身份标识</td>
              <td><img :src="vipList[0].vsrc" class="vip-level-0"></img></td>
              <td><img :src="vipList[1].vsrc" class="vip-level-1"></img></td>
              <td><img :src="vipList[2].vsrc" class="vip-level-2"></img></td>
              <td><img :src="vipList[3].vsrc" class="vip-level-3"></img></td>
              <td><img :src="vipList[4].vsrc" class="vip-level-4"></img></td>
              <td><img :src="vipList[5].vsrc" class="vip-level-5"></img></td>
              <td><img :src="vipList[6].vsrc" class="vip-level-6"></img></td>
              <td><img :src="vipList[7].vsrc" class="vip-level-7"></img></td>
            </tr>
            <tr>
              <td>成长值</td>
              <td>0</td>
              <td>10-4999</td>
              <td>5000-9999</td>
              <td>10000-49999</td>
              <td>50000-99999</td>
              <td>100000-499999</td>
              <td>500000-1199999</td>
              <td>1200000+</td>
            </tr>
          </tbody>
        </table>
        <br>
        <br>
        <h2 class="vip-title-s">成长体系计算规则</h2>
        <br>
        <table cellspacing="0" cellpadding="0" bordercolor="#f5f5f5" border="1">
          <tbody>
            <tr>
              <th width="100">获取途径</th>
              <th>游戏充值</th>
              <th>日常任务</th>
              <th>活动赠送</th>
            </tr>
            <tr>
              <td>规则</td>
              <td>1rmb=10成长值</td>
              <td>通过完成任务获得对应的成长值</td>
              <td>未开启</td>
            </tr>
            <tr>
              <td>备注</td>
              <td>获得成长值数量实际充值金额为准</td>
              <td>不同的任务提供不同数量的成长值</td>
              <td>敬请期待</td>
            </tr>
          </tbody>
        </table>
        <br>
        <br>
        <h2 class="vip-title-s">成长值有效周期</h2>
        <br>
        <p style="line-height: 30px;">
          成长值有效周期为一个完整自然年（365天）
          <br>
          每天1月1日根据玩家前一个周期内的成长值获取总和(游戏充值+日常任务+活动赠送)进行定级。
          <br>
          定级后依完整自然年为一个服务周期,周期结束后会重新根据玩家当前自然年内的成长值获取总和进行重新定级。
          <br>
          举例1：玩家A，根据前一年成长值总和1月1日成为大玩家V1，次年1月1日过期。
          <br>
          举例2：玩家B，根据前一年成长值总和1月1日成为大玩家V3，12月1日通过充值和任务累计成为超级玩家V4，大玩家V3被代替，更新有效周期，次年12月1日重新定级。
        </p>
      </div>
    </div>
    <Footer></Footer>
    <SuspendSide></SuspendSide>
    <SuspendMember :suspendType="suspendType" :suspendState="suspendState"
      @changeSuspendState="changeSuspendState" @changeSuspendType="changeSuspendType"
      @changeLoginState="changeLoginState"></SuspendMember>
  </div>
</template>
<script>
import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';
import SuspendSide from '../../components/SuspendSide';
import SuspendMember from '../../components/SuspendMember';
export default {
  components: {
    Footer, Header,SuspendSide,SuspendMember
  },
  metaInfo(){
    return {
      title:"成长体系_"+this.$store.state.home.title,
      meta:[
        { name:'keywords', content:this.$store.state.home.keywords},
        { name:'description',content:this.$store.state.home.description}
      ]
    }
  },
  computed:{
    vipList(){
      return this.$store.state.constant.vipList;
    }
  },
  asyncData({store,route}){
    return store.dispatch('initSeo',{store:store});
  },
  data() {
    return {
      userAvatar:'',
      tabDirector:0,
      setTimer:'',
      suspendState:false,
      suspendType:0,
      loginState:false
    };
  },
  methods:{
    changeSuspendState(value){
      this.suspendState = value;
    },
    changeSuspendType(value){
      this.suspendType = value;
    },
    changeLoginState(value){
      this.loginState = value;
    },
    mouseOver(value){
      clearTimeout(this.setTimer); 
      this.tabDirector = value;
    },
    mouseOut(){
      var vip = this;
      this.setTimer = setTimeout(function(){
        vip.tabDirector = 0;
      },300); 
    },
  }
};
</script>
<style src="@/assets/css/vip.css" scoped></style>